function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m482.480469 54h-34v-24c0-16.542969-13.457031-30-30-30h-310c-16.542969 0-30 13.457031-30 30v152.53125l-13.128907-13.132812c-7.179687-7.175782-16.71875-11.128907-26.871093-11.128907-10.148438 0-19.691407 3.953125-26.871094 11.128907-14.8125 14.816406-14.8125 38.925781 0 53.742187l66.871094 66.871094v137.988281c0 16.542969 13.457031 30 30 30h34v24c0 16.542969 13.457031 30 30 30h310c16.542969 0 30-13.457031 30-30v-398c0-16.542969-13.457031-30-30-30zm-374-34h310c5.515625 0 10 4.484375 10 10v398c0 5.515625-4.484375 10-10 10h-121.617188l-25.996093-62.03125c-.503907-1.199219-1.234376-2.289062-2.152344-3.207031l-66.589844-66.589844-103.644531-103.640625v-172.53125c0-5.515625 4.488281-10 10-10zm-62.042969 209.679688 25.453125-25.453126 175.609375 175.605469-25.457031 25.457031zm211.742188 167.757812 13.367187 31.898438-31.898437-13.367188zm-232.425782-213.894531c3.398438-3.402344 7.917969-5.273438 12.726563-5.273438 4.808593 0 9.328125 1.871094 12.730469 5.273438l6.539062 6.539062-25.453125 25.457031-6.542969-6.542968c-7.019531-7.015625-7.019531-18.433594 0-25.453125zm72.726563 244.457031v-117.988281l116.492187 116.488281c.917969.917969 2.007813 1.648438 3.207032 2.152344l22.300781 9.347656h-132c-5.511719 0-10-4.484375-10-10zm394 54c0 5.515625-4.484375 10-10 10h-310c-5.511719 0-10-4.484375-10-10v-24h256c16.542969 0 30-13.457031 30-30v-354h34c5.515625 0 10 4.484375 10 10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m161.480469 74h204c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10h-204c-5.519531 0-10 4.476562-10 10s4.476562 10 10 10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m365.480469 103.007812h-70c-5.519531 0-10 4.476563-10 10 0 5.519532 4.480469 10 10 10h70c5.523437 0 10-4.480468 10-10 0-5.523437-4.476563-10-10-10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m365.480469 250.023438h-70c-5.519531 0-10 4.480468-10 10 0 5.523437 4.480469 10 10 10h70c5.523437 0 10-4.476563 10-10 0-5.519532-4.476563-10-10-10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m231.480469 250.023438h-29.332031c-5.523438 0-10 4.480468-10 10 0 5.523437 4.476562 10 10 10h29.332031c5.523437 0 10-4.476563 10-10 0-5.519532-4.476563-10-10-10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m365.480469 299.460938h-70c-5.519531 0-10 4.476562-10 10 0 5.523437 4.480469 10 10 10h70c5.523437 0 10-4.476563 10-10 0-5.523438-4.476563-10-10-10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m161.480469 123.007812h70c5.523437 0 10-4.480468 10-10 0-5.523437-4.476563-10-10-10h-70c-5.519531 0-10 4.476563-10 10 0 5.519532 4.476562 10 10 10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m161.480469 172.011719h164c5.523437 0 10-4.476563 10-10 0-5.523438-4.476563-10-10-10h-164c-5.519531 0-10 4.476562-10 10 0 5.523437 4.476562 10 10 10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m365.480469 152.011719c-2.628907 0-5.210938 1.066406-7.070313 2.929687-1.859375 1.859375-2.929687 4.4375-2.929687 7.070313 0 2.628906 1.070312 5.207031 2.929687 7.066406 1.859375 1.863281 4.441406 2.933594 7.070313 2.933594 2.628906 0 5.210937-1.070313 7.070312-2.933594 1.859375-1.859375 2.929688-4.4375 2.929688-7.066406 0-2.632813-1.070313-5.210938-2.929688-7.070313-1.859375-1.863281-4.441406-2.929687-7.070312-2.929687zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m161.480469 221.019531h204c5.523437 0 10-4.476562 10-10 0-5.523437-4.476563-10-10-10h-204c-5.519531 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10zm0 0",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}));

var SvgSubmitnew = function SvgSubmitnew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511 512",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubmitnew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Submitnew.a466c508.svg";
export { ForwardRef as ReactComponent };